import React from "react";
import CheckoutForm from "../components/CheckoutForm";
import CartSummary from "../components/CartSummary";

const Checkout = () => {
  return (
   <div className="min-h-screen px-4 pt-28 md:pt-18 lg:pt-1 pb-8">
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 px-4 lg:px-8">
      {/* Checkout Form */}
      <div className="lg:col-span-2">
        <CheckoutForm />
      </div>

      {/* Cart Summary */}
      <div className="lg:col-span-1 pr-2 lg:pr-6">
        <CartSummary />
      </div>
    </div>
    </div>
  );
};

export default Checkout;
